import { type RouteLocation, type RouteRecordRaw } from 'vue-router';

import { ROUTE_DATA } from '@/constants/routes.constants';
import { routerHelper } from '@/services/router-helper';

const ObligationInstanceOverview = (): unknown => {
    return import(/* webpackPrefetch: true */ './obligation-instance-overview-page.vue');
};

export const obligationInstanceOverviewRoute: RouteRecordRaw = {
    ...ROUTE_DATA.OBLIGATION_OVERVIEW_PAGE,
    components: {
        main: ObligationInstanceOverview
    },
    props: {
        main(route: RouteLocation): { obligationInstanceId?: number } {
            return { obligationInstanceId: routerHelper.parseParamToInt(route.params.id as string) };
        }
    }
};
